<i18n>
{
	"en": {
		"traffic": "Traffic",
		"cargoCarriers": "Cargo Carriers",
		"cargoCarrierTypes": "Cargo Carrier Types",
		"accessRequests": "Requests",
		"bannedUsers": "Banned users",
		"newUser": "New User",
		"users": "Users",
		"goodsTypes": "Goods Types",
		"deviations": "Deviations",
		"tripTemplates": "Trip Templates",
		"orderTemplates": "Order Templates",
		"edi" : "EDI",
		"messages" : "Messages",
		"edipart" : "Maintain EDI Parts",
		"incoterms": "Incoterms",
		"packageTypes": "Package Types",
		"tripAddresses": "Trip Addresses",
		"references": "References",
		"drivers": "Drivers",
		"addresses": "Addresses",
		"preferredVendors": "Preferred Vendors",
		"vendors": "Vendors"
	},
	"no": {
		"traffic": "Trafikk",
		"users": "Brukere",
		"cargoCarriers": "Lastbærere",
		"cargoCarrierTypes": "Lastbærertyper",
		"bannedUsers": "Utestengte brukere",
		"accessRequests": "Forespørsler",
		"newUser": "Ny bruker",
		"goodsTypes": "Godstyper",
		"deviations": "Avvik",
		"tripTemplates": "Turmaler",
		"orderTemplates": "Oppdragsmaler",
		"edi" : "EDI",
		"messages" : "Meldinger",
		"edipart" : "Vedlikehold EDI parter",
		"incoterms": "Incoterms",
		"packageTypes": "Pakketyper",
		"tripAddresses": "Turadresser",
		"searchOrder": "Søk oppdrag",
		"references": "Referanser",
		"drivers": "Sjåfører",
		"addresses": "Adresser",
		"preferredVendors": "Foretrukne Leverandører",
		"vendors": "Leverandører"
	}
}
</i18n>
<template>
	<t-nav-layer :company="companyName" :showSlide="showNavMenu" @close="setNavMenuHidden" >
		<t-menu>
			<t-menu-nav-group :title="$t('traffic')" bold>
				<t-menu-nav-item
					:to="{name: 'addresses'}"
					:value="$t('addresses')"
					icon="globe"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'tripAddresses'}"
					:value="$t('tripAddresses')"
					icon="globe"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'cargoCarriers'}"
					:value="$t('cargoCarriers')"
					icon="truck-front"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'cargoCarrierTypes'}"
					:value="$t('cargoCarrierTypes')"
					icon="truck-front"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'drivers'}"
					:value="$t('drivers')"
					icon="person"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'goodsTypes'}"
					:value="$t('goodsTypes')"
					icon="order-explosive"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'packageTypes'}"
					:value="$t('packageTypes')"
					icon="order"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'deviations'}"
					:value="$t('deviations')"
					icon="warning-sign"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'tripTemplates'}"
					:value="$t('tripTemplates')"
					icon="trip"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'orderTemplates'}"
					:value="$t('orderTemplates')"
					icon="order"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'incoterms'}"
					:value="$t('incoterms')"
					icon="book"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'references'}"
					:value="$t('references')"
					icon="comment"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'preferredVendors'}"
					:value="$t('preferredVendors')"
					icon="new-link"
					iconType="bp"
					iconSize="sm"
					bold
				/>
				<t-menu-nav-item
					:to="{name: 'vendors'}"
					:value="$t('vendors')"
					icon="office"
					iconType="bp"
					iconSize="sm"
					bold
				/>

			</t-menu-nav-group>
			<t-menu-nav-group v-if="getUserHasAdminAccess" :title="$t('users')" bold>
				<t-menu-nav-item
					:to="{name: 'userList'}"
					:value="$t('users')"
					icon="user"
					iconType="bp"
					bold
				/>
				<t-menu-nav-item
					:value="$t('newUser')"
					icon="plus"
					iconType="bp"
					bold
					@click="toggleNewUserModal(true)"
				/>
			</t-menu-nav-group>

			<t-menu-nav-group v-if="getUserHasAdminAccess" :title="$t('edi')" bold>
				<t-menu-nav-item
					v-if="isTimpexSupport"
					:value="$t('edipart')"
					icon="database"
					iconType="bp"
					iconSize="sm"
					bold
					:to="{name: 'edipartMaintenance'}"
				/>
			</t-menu-nav-group>
		</t-menu>

		<new-user />

		<template slot="nav-footer-prepend">
			<OrderSearchInput needReroute />
		</template>
	</t-nav-layer>
</template>

<script>
import NewUser from '../users/NewUser';
import {
	mapState, mapGetters, mapActions, mapMutations
} from 'vuex';
import OrderSearchInput from '@/modules/loadPlanningList/OrderSearch/OrderSearchInput';
import TMenuNavItem from '@/components/evergreen/menu/TMenuNavItem';
import TNavLayer from '@/components/evergreen/timpex/layers/TNavLayer';
import TMenu from '@/components/evergreen/menu/TMenu';
import TMenuNavGroup from '@/components/evergreen/menu/TMenuNavGroup';

export default {
	name: 'Maintenance',
	components: { TMenuNavGroup, TMenu, TNavLayer, TMenuNavItem, NewUser, OrderSearchInput },
	computed: {
		...mapState(['showNavMenu']),
		...mapGetters('login',[
			'company',
			'getUserHasAdminAccess',
			'getUser',
			'isTimpexSupport'
		]),
		companyName() {
			return this.company ? this.company.displayName : 'Kundenavn';
		}
	},
	methods: {
		...mapActions(['setNavMenuHidden']),
		...mapMutations('users', ['toggleNewUserModal']),
	},
};
</script>

<style>

</style>
